import React, { useContext, useEffect, useState } from "react";
import FormContext from "../../context/FormContext";

const Accordion = (props) => {
  const context = useContext(FormContext);
  const { handlefieldremove, Fields, setFields } = context;
  const [user, setUser] = useState([]);

  const handleFormData = (newData) => {
    const index = Fields.findIndex((obj) => obj.id === user.id);
    if (index !== -1) {
      Fields[index] = newData;
    }

    setFields(Fields);
  };

  const handleChange = (e) => {
    const newData = { ...user, [e.target.name]: e.target.value };
    setUser({ ...user, [e.target.name]: e.target.value });

    handleFormData(newData);
  };

  useEffect(() => {
    setUser(props);
  }, [props]);

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`headingOne${user.pointer}`}>
        <button
          className="accordion-button collapsed"
          style={{ textTransform: "capitalize" }}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapseOne${user.pointer}`}
          aria-expanded="false"
          aria-controls={`collapseOne${user.pointer}`}
        >
          {user.labelName ? user.labelName : user.labelType}
        </button>
      </h2>
      <div
        id={`collapseOne${user.pointer}`}
        className="accordion-collapse collapse "
        aria-labelledby={`#headingOne${user.pointer}`}
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          <div className="row">
            {user.mandatory ? null : (
              <div className="col-12 d-flex ">
                <div className="ms-auto">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => handlefieldremove(user.id)}
                  >
                    <i
                      style={{ cursor: "pointer" }}
                      className="fa-solid fa-trash-can text-light"
                    ></i>
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-md-4">
              <label className="my-1">Label Name</label>
              <input
                name="labelName"
                onChange={(e) => handleChange(e)}
                value={user.labelName}
                className="form-control"
                required
              />
            </div>
            <div className="col-md-4">
              <label className="my-1">Is Required</label>
              <select
                required
                name="isRequired"
                onChange={(e) => handleChange(e)}
                value={user.isRequired}
                className="form-control"
              >
                <option value="1">True</option>
                <option value="0">False</option>
              </select>
            </div>
            {/* <div className="col-md-4">
              <label className="my-1">Validation Pattern</label>
              <input
                name="validationPattern"
                onChange={(e) =>
                  setUser({ ...user, [e.target.name]: e.target.value })
                }
                value={user.validationPattern}
                className="form-control"
              />
            </div> */}
            {/* <div className="col-md-4">
              <label className="my-1">Form Type</label>
              <input
                name="formType"
                onChange={(e) =>
                  setUser({ ...user, [e.target.name]: e.target.value })
                }
                value={user.formType}
                className="form-control"
              />
            </div> */}
            <div className="col-md-4">
              <label className="my-1">Label Type</label>
              <input
                disabled
                name="labelType"
                value={user.labelType}
                className="form-control"
              />
            </div>
            {user.moreoption !== undefined && (
              <div className="col-md-4 ">
                <div className="mx-auto my-auto">
                  <label className="my-1"> Options</label>
                  <textarea
                    name="moreoption"
                    onChange={(e) => handleChange(e)}
                    placeholder={"Option Sepereted By Comma"}
                    className="form-control"
                    rows={4}
                    required
                    defaultValue={user.moreoption}
                  ></textarea>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
